var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.37658 15.1818L9.40258 16.8118V11.9706C9.40258 11.7941 9.44458 11.6208 9.52258 11.4656L13.8226 2.99963H3.14258L7.26458 11.4826C7.33858 11.6336 7.37658 11.8016 7.37658 11.9706V15.1818ZM10.4032 20.0123C10.1902 20.0123 9.97723 19.94 9.80023 19.7964L5.77423 16.5587C5.52423 16.3578 5.37723 16.0441 5.37723 15.7113V12.2301L0.612229 2.42439C0.451229 2.09477 0.464229 1.70029 0.646229 1.38343C0.827229 1.06657 1.15123 0.873047 1.50023 0.873047H15.5002C15.8522 0.873047 16.1782 1.06976 16.3592 1.39193C16.5392 1.71305 16.5472 2.11178 16.3802 2.4414L11.4032 12.2396V18.949C11.4032 19.352 11.1892 19.7209 10.8492 19.9006C10.7082 19.9751 10.5552 20.0123 10.4032 20.0123Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.310354425a77a1c4e7fe90e41c1cdb40.svg";
export { ForwardRef as ReactComponent };